import React, { useEffect, useRef, useState } from 'react';
import { GetAllProductAttributesWithValues } from '../../Services/AttributeService';

function calculatePercents(value) {
  if (!value || isNaN(value)) return { p5: 0, p10: 0, p15: 0 };

  const num = parseFloat(value);

  return {
    p5: (num * 5) / 100,
    p10: (num * 10) / 100,
    p15: (num * 15) / 100
  };
}

// 'onQuantityChange' prop ko list se hata diya gaya hai
const ChooseQuantity = ({ selectedProducts = [], onWheatSizeChange, onProductQuantitiesChange, xmlData, autoproductQuantities }) => {
  const [productAttributes, setProductAttributes] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [productQuantities, setProductQuantities] = useState({});
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [customQuantities, setCustomQuantities] = useState({});
  const [totalWheatQty, setTotalWheatQty] = useState(0);
  const firstLoad = useRef(true);

  useEffect(() => {
    if (selectedProducts.length > 0) {
      fetchAttributesForAllProducts();

      // Only run quantity initialization once (on first load)
      if (!firstLoad.current) return;

      let initialQuantities = {};

      // Priority 1: Prefill from autoproductQuantities (edit mode or going back)
      if (autoproductQuantities && Object.keys(autoproductQuantities).length > 0) {
        Object.entries(autoproductQuantities).forEach(([productId, item]) => {
          const weight = item?.weight;
          const totalPrice = item.totalPrice;

          if (!productId || !weight) return;

          const product = selectedProducts.find(p => p.id == productId);
          if (!product) return;

          const categoryId = product.categoryId || product.category?.id;
          const basePrice =
            categoryId === 1
              ? (product.discountPrice || 0)
              : (product.price || 0);

          initialQuantities[productId] = {
            selectedAttributeId: productId,
            selectedValue: `${weight} Kg`,
            weight: parseFloat(weight),
            basePrice,
            additionalPrice: 0,
            totalPrice: parseFloat(totalPrice)
          };
        });
        firstLoad.current = false;
        setProductQuantities(initialQuantities);
      }


      // Then, load/merge with saved quantities from localStorage
      const savedQuantities = localStorage.getItem('customise-quantities');
      if (savedQuantities) {
        try {
          const parsed = JSON.parse(savedQuantities);
          // Merge XML data with localStorage data, preferring XML data for existing products
          selectedProducts.forEach(product => {
            if (!initialQuantities[product.id] && parsed[product.id]) {
              initialQuantities[product.id] = parsed[product.id];
            } else if (!initialQuantities[product.id]) {
              // For new products not in XML or localStorage, initialize with base price only
              const categoryId = product.categoryId || product.category?.id;
              const basePrice = categoryId === 1
                ? (product.discountPrice || 0)
                : (product.price || 0);
              initialQuantities[product.id] = {
                selectedAttributeId: null,
                selectedValue: null, // Will be set by attributes useEffect
                weight: 0, // Will be set by attributes useEffect
                basePrice: basePrice,
                additionalPrice: 0,
                totalPrice: 0 // Will be calculated when first item is selected
              };
            }
          });
        } catch (error) {
          console.error('Error parsing saved quantities:', error);
          // Fall back to XML data or empty initialization
          selectedProducts.forEach(product => {
            if (!initialQuantities[product.id]) {
              const categoryId = product.categoryId || product.category?.id;
              const basePrice = categoryId === 1
                ? (product.discountPrice || 0)
                : (product.price || 0);
              initialQuantities[product.id] = {
                selectedAttributeId: null,
                selectedValue: null,
                weight: 0,
                basePrice: basePrice,
                additionalPrice: 0,
                totalPrice: 0
              };
            }
          });
        }
      } else {
        // No saved quantities, use XML data or initialize empty
        selectedProducts.forEach(product => {
          if (!initialQuantities[product.id]) {
            const categoryId = product.categoryId || product.category?.id;
            const basePrice = categoryId === 1
              ? (product.discountPrice || 0)
              : (product.price || 0);
            initialQuantities[product.id] = {
              selectedAttributeId: null,
              selectedValue: null,
              weight: 0,
              basePrice: basePrice,
              additionalPrice: 0,
              totalPrice: 0
            };
          }
        });
      }

      setProductQuantities(initialQuantities);
    }
  }, [selectedProducts, autoproductQuantities]);

  useEffect(() => {
    // Save quantities to localStorage whenever they change
    if (Object.keys(productQuantities).length > 0) {
      localStorage.setItem('customise-quantities', JSON.stringify(productQuantities));
    }
  }, [productQuantities]);

  useEffect(() => {
    // Pass productQuantities to parent component whenever it changes
    if (onProductQuantitiesChange) {
      onProductQuantitiesChange(productQuantities);
    }
  }, [productQuantities, onProductQuantitiesChange]);

  useEffect(() => {
    // Calculate total wheat quantity
    let totalWheat = 0;
    selectedProducts.forEach(product => {
      const categoryId = product.categoryId || product.category?.id;
      if (categoryId === 1) { // Wheat products
        const qty = productQuantities[product.id];
        if (qty && qty.weight) {
          totalWheat += parseFloat(qty.weight);
        }
      }
    });
    setTotalWheatQty(totalWheat);
  }, [productQuantities, selectedProducts]);

  // --- YEH EFFECT HATA DIYA GAYA HAI ---
  // Kyunki yeh parent component (CustomiseSidebar) mein conflict kar raha tha.
  /*
  useEffect(() => {
    if (onQuantityChange && Object.keys(productQuantities).length > 0) {
      let totalPrice = 0;
      let totalWeight = 0;

      Object.values(productQuantities).forEach(qty => {
        totalPrice += parseFloat(qty.totalPrice || 0);
        totalWeight += parseFloat(qty.weight || 0);
      });

      console.log('Total calculation:', {
        totalPrice,
        totalWeight,
        productQuantities
      });

      onQuantityChange(totalPrice, totalWeight);
    }
  }, [productQuantities, onQuantityChange]);
  */
  // --- (Hata diya) ---

  useEffect(() => {
    // Auto-select first available attribute for each product when attributes are loaded
    if (Object.keys(productAttributes).length > 0 && selectedProducts.length > 0) {
      setProductQuantities(prev => {
        const updated = { ...prev };
        let hasChanges = false;

        selectedProducts.forEach(product => {
          const productId = product.id;
          const currentQuantity = updated[productId];

          // Only auto-select if no selection exists
          if (!currentQuantity?.selectedValue) {
            const attributes = productAttributes[productId] || [];
            const allAttributeValues = [];

            attributes.forEach(attribute => {
              attribute.values?.forEach(value => {
                allAttributeValues.push({
                  attributeId: attribute.id,
                  valueId: value.id,
                  valueName: value.name,
                  increasePrice: value.increasePrice
                });
              });
            });

            // Select the first available option
            if (allAttributeValues.length > 0) {
              const firstOption = allAttributeValues[0];
              const categoryId = product.categoryId || product.category?.id;
              const basePrice = parseFloat(
                categoryId === 1
                  ? (product.discountPrice || 0)
                  : (product.price || 0)
              );

              const weight = parseFloat(firstOption.valueName?.replace(/[^0-9.]/g, '') || 1);
              const increasePerKg = parseFloat(firstOption.increasePrice || 0);
              const totalAdditional = increasePerKg * weight;
              const totalPrice = (weight * basePrice) + totalAdditional;

              updated[productId] = {
                selectedAttributeId: firstOption.attributeId,
                selectedValue: firstOption.valueName,
                weight: weight,
                basePrice: basePrice,
                increasePerKg: increasePerKg,
                totalAdditional: totalAdditional,
                totalPrice: totalPrice
              };
              hasChanges = true;
            }
          }
        });

        return hasChanges ? updated : prev;
      });
    }
  }, [productAttributes, selectedProducts]);

  useEffect(() => {
    // Collect wheat size data and pass to parent
    if (onWheatSizeChange && Object.keys(productQuantities).length > 0) {
      const wheatSizes = [];
      selectedProducts.forEach(product => {
        const categoryId = product.categoryId || product.category?.id;
        if (categoryId === 1) { // Wheat products
          const quantity = productQuantities[product.id];
          if (quantity) {
            wheatSizes.push({
              id: quantity.selectedAttributeId,
              attributeId: quantity.selectedAttributeId,
              valueId: quantity.selectedAttributeId,
              value: quantity.selectedValue,
              name: quantity.selectedValue,
              increasePrice: quantity.additionalPrice || 0
            });
          }
        }
      });

      onWheatSizeChange(wheatSizes);
    }
  }, [productQuantities, selectedProducts, onWheatSizeChange]);

  const fetchAttributesForAllProducts = async () => {
    setLoading(true);
    setError(null);

    try {

      // Fetch attributes only for wheat products (categoryId === 1)
      const wheatProducts = selectedProducts.filter(product => (product.categoryId || product.category?.id) === 1);
      const attributePromises = wheatProducts.map(async (product) => {
        try {

          // Call API with individual productId and attributeIds=3
          const response = await GetAllProductAttributesWithValues({
            productId: product.id,
            attributeIds: 3
          });

          return {
            productId: product.id,
            attributes: response.data || []
          };
        } catch (err) {
          return {
            productId: product.id,
            attributes: []
          };
        }
      });

      // Wait for all API calls to complete
      const results = await Promise.all(attributePromises);

      // Store attributes mapped by product ID
      const attributesMap = {};
      results.forEach(result => {
        attributesMap[result.productId] = result.attributes;
      });

      setProductAttributes(attributesMap);

    } catch (err) {
      setError('Failed to load product attributes.');
    } finally {
      setLoading(false);
    }
  };

  const toggleDropdown = (productId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const closeDropdown = (productId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [productId]: false
    }));
  };

  const handleQuantityChange = (productId, attributeId, value, increasePrice) => {

    setProductQuantities(prev => {
      const product = selectedProducts.find(p => p.id === productId);

      const categoryId = product?.categoryId || product?.category?.id;
      const basePrice = parseFloat(
        categoryId === 1
          ? (product?.discountPrice || 0)
          : (product?.price || 0)
      );

      // weight parsed from option text (e.g., "5 Kg" -> 5)
      const weight = parseFloat(value?.replace('(5%)', '').replace('(10%)', '').replace('(15%)', '').replace(/[^0-9.]/g, '') || 1);

      // Treat increasePrice as "per kg" value (safe parse)
      const increasePerKg = parseFloat(increasePrice || 0);

      // total additional = increasePerKg * weight
      const totalAdditional = increasePerKg * weight;

      // Calculate total price correctly: (weight * basePrice) + (increasePerKg * weight)
      const totalPrice = (weight * basePrice) + totalAdditional;

      // For grains and pulses, remove percentage from selectedValue
      const selectedValue = categoryId === 1
        ? value
        : value.replace(/\s*\([^)]*\)$/, '');

      return {
        ...prev,
        [productId]: {
          ...prev[productId],
          selectedAttributeId: attributeId,
          selectedValue: selectedValue,
          weight: weight,
          basePrice: basePrice,
          increasePerKg: increasePerKg,     // store per-kg increase
          totalAdditional: totalAdditional, // store total additional for this product
          totalPrice: totalPrice
        }
      };
    });

    // Close dropdown after selection
    closeDropdown(productId);
  };

  const handleCustomQuantitySelect = (productId) => {
    const customValue = customQuantities[productId];
    if (!customValue || isNaN(parseFloat(customValue))) {
      alert('Please enter a valid quantity');
      return;
    }

    const customWeight = parseFloat(customValue);
    const percentage = totalWheatQty > 0 ? (customWeight / totalWheatQty) * 100 : 0;
    // const customQuantityValue = `${customWeight.toFixed(2)} KG (${percentage.toFixed(2)}%)`;
    const customQuantityValue = `${customWeight.toFixed(2)} KG`;

    // Add custom quantity to the dropdown options
    setProductAttributes(prev => {
      const updated = { ...prev };
      if (!updated[productId]) {
        updated[productId] = [];
      }

      // Check if custom quantity already exists
      const existingIndex = updated[productId].findIndex(attr =>
        attr.values?.some(val => val.name === customQuantityValue)
      );

      if (existingIndex === -1) {
        // Add new attribute with custom value
        updated[productId].push({
          id: `custom-${Date.now()}`,
          name: 'Custom Quantity',
          values: [{
            id: `custom-value-${Date.now()}`,
            name: customQuantityValue,
            increasePrice: 0
          }]
        });
      }

      return updated;
    });

    // Select the custom quantity
    handleQuantityChange(productId, `custom-${Date.now()}`, customQuantityValue, 0);

    // Clear the custom quantity input and hide it
    setCustomQuantities(prev => ({
      ...prev,
      [productId]: ''
    }));
  };

  const getAttributesForProduct = (product) => {

    // Get all attributes specific to this product
    const productSpecificAttributes = productAttributes[product.id] || [];

    return productSpecificAttributes;
  };

  const groupProductsByCategory = () => {
    const grouped = {
      wheat: [],
      grains: [],
      pulses: []
    };

    selectedProducts.forEach(product => {
      const categoryId = product.categoryId || product.category?.id;
      if (categoryId === 1) {
        grouped.wheat.push(product);
      } else if (categoryId === 2) {
        grouped.grains.push(product);
      } else if (categoryId === 3) {
        grouped.pulses.push(product);
      }
    });

    return grouped;
  };

  const renderProductDropdown = (product) => {
    const attributes = getAttributesForProduct(product);
    const currentQuantity = productQuantities[product.id];

    const categoryId = product.categoryId || product.category?.id;
    const basePrice = categoryId === 1
      ? (product.discountPrice || 0)
      : (product.price || 0);

    const displayPrice = currentQuantity?.totalPrice?.toFixed(2) || basePrice;

    // Extract weight only for display (remove percentage part for grains/pulses)
    const displayValue = currentQuantity?.selectedValue
      ? (categoryId === 1
        ? currentQuantity.selectedValue
        : currentQuantity.selectedValue.replace(/\s*\([^)]*\)$/, ''))
      : 'Select Quantity';

    let dropdownOptions = [];

    if (categoryId === 1) { // Wheat products - use API attributes
      // If product has attributes and values, show dynamic dropdown
      const allAttributeValues = [];
      attributes?.forEach(attribute => {
        attribute.values?.forEach(value => {
          allAttributeValues.push({
            attributeId: attribute.id,
            attributeName: attribute.name,
            valueId: value.id,
            valueName: value.name,
            increasePrice: value.increasePrice
          });
        });
      });

      // If no dynamic attributes found, fallback to default quantity list
      dropdownOptions = allAttributeValues.map(v => ({
        id: `${v.attributeId}-${v.valueId}`,
        name: v.valueName,
        increasePrice: v.increasePrice,
        attributeId: v.attributeId
      }));
    } else { // Grains and Pulses - use percentage-based quantities
      const percents = calculatePercents(totalWheatQty);
      dropdownOptions = [
        {
          id: `percent-5-${product.id}`,
          name: `${percents.p5.toFixed(2)} KG (5%)`,
          increasePrice: 0,
          attributeId: `percent-5-${product.id}`
        },
        {
          id: `percent-10-${product.id}`,
          name: `${percents.p10.toFixed(2)} KG (10%)`,
          increasePrice: 0,
          attributeId: `percent-10-${product.id}`
        },
        {
          id: `percent-15-${product.id}`,
          name: `${percents.p15.toFixed(2)} KG (15%)`,
          increasePrice: 0,
          attributeId: `percent-15-${product.id}`
        }
      ];
    }

    return (
      <div className={'list-box'} key={product.id}>
        <div className={'d-flex align-items-center justify-content-between gap-2 mb_10'}>
          <p className={'fs_16 mb-0 fw_400 text-color'}>{product.name}</p>
          <p className={'fs_12 fw_500 mb-0 text-colors'}>
            {displayValue} {displayPrice} ₹
          </p>
        </div>
        <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id={`dropdown-${product.id}`}
            onClick={() => toggleDropdown(product.id)}
            aria-expanded={openDropdowns[product.id] || false}
          >
            {displayValue}
          </button>
          <ul className={`dropdown-menu ${openDropdowns[product.id] ? 'show' : ''}`} aria-labelledby={`dropdown-${product.id}`}>
            {dropdownOptions.map((option) => (
              <li key={option.id}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleQuantityChange(product.id, option.attributeId || null, option.name, option.increasePrice);
                  }}
                >
                  <p className={'mb-0'}>
                    {option.name}
                    {option.increasePrice > 0 && ` (+${option.increasePrice.toFixed(2)} ₹)`}
                  </p>
                  <div className="form-check custom-radio">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={currentQuantity?.selectedValue === option.name}
                      onChange={() => { }}
                    />
                  </div>
                </a>
              </li>
            ))}
            {/* Custom quantity input */}
            <li style={{ borderTop: '1px solid #dee2e6', padding: '10px' }}>
              <div className="dropdown-item">
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="number"
                    step="0.1"
                    min="0.1"
                    className="form-control form-control-sm"
                    placeholder="Custom qty (e.g., 2.5)"
                    value={customQuantities[product.id] || ''}
                    onChange={(e) => setCustomQuantities(prev => ({
                      ...prev,
                      [product.id]: e.target.value
                    }))}
                    style={{ width: '120px', fontSize: '12px' }}
                  />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleCustomQuantitySelect(product.id)}
                    disabled={!customQuantities[product.id] || isNaN(parseFloat(customQuantities[product.id]))}
                    style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#a37c4d', borderColor: '#a37c4d' }}
                  >
                    Select
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const renderCategoryProducts = (products, categoryName) => {
    if (products.length === 0) return null;

    return (
      <div className="grid-box" key={categoryName}>
        <div className={'d-flex align-items-center justify-content-between gap-2 mb_20'}>
          <h5 className={'fs_24 fw_700 lh-1 mb-0 text-capitalize'}>
            {categoryName} ({products.length})
          </h5>
        </div>
        <div className={'dropdown-list'}>
          {products.map(product => renderProductDropdown(product))}
        </div>
      </div>
    );
  };

  if (selectedProducts.length === 0) {
    return (
      <div>
        <div className="section-title chose-quantity">
          <h5>Choose Your Basket Quantity</h5>
          <p>Select from Quantity to start your custom flour mix.</p>
        </div>
        <div className={'content-box'}>
          <p className="text-center text-muted">No products selected. Please go back and select products.</p>
        </div>
      </div>
    );
  }

  const groupedProducts = groupProductsByCategory();

  return (
    <div>
      <div className="section-title chose-quantity">
        <h5>Choose Your Basket Quantity</h5>
        <p>Select from Quantity to start your custom flour mix.</p>
      </div>

      <div className={'content-box'}>
        {loading ? (
          <p className="text-center">Loading quantities...</p>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <div className="choose-your-grid">
            {renderCategoryProducts(groupedProducts.wheat, 'Wheat')}
            {renderCategoryProducts(groupedProducts.grains, 'Grains')}
            {renderCategoryProducts(groupedProducts.pulses, 'Pulses')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChooseQuantity;